module.exports = __webpack_public_path__ + "img/globe.bab747d7.svg";